/**
 * Classe usuário.
 */
export class UserModel<T> {

    private _nome: string;
    private _img: string;
    private _menus: T[] = [];

    constructor() { };

    get nome(): string {
        return this._nome;
    }

    set nome(nome: string) {
        this._nome = nome;
    }

    get img(): string {
        return this._img;
    }

    set img(img: string) {
        this._img = img;
    }

    get menus(): T[] {
        return this._menus;
    }

    addMenu(menu: T): void {
        if (!this._menus) {
            this._menus = [];
        }

        if (menu) {
            this._menus.push(menu);
        }
    }

    addMenus(menus: Array<T>): void {
        this._menus = [];

        this._menus = menus;
    }
}